import React, { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import baseTransferOptionStyles from './baseTransferOptionStyles';
import Translation from '../../../../common/components/translation/Translation';

export interface IBaseTransferOptionProps {
  type: string;
  options: string[];
}

const BaseTransferOption: FunctionComponent<IBaseTransferOptionProps> = ({ type, options }) => {
  const styles = baseTransferOptionStyles();

  if (!options?.length) {
    return null;
  }

  return (
    <Box className={styles.container} pl={2}>
      <Typography className={styles.optionTitle} data-test={`transfer:group:title:${type}`}>
        <Translation id={`trans__configurator__stock__transfer_modal_${type}`} />
      </Typography>
      <Box display="flex" flexDirection="column" pl={2}>
        {options.map(option => (
          <Typography variant="caption" key={option} data-test={`transfer:group:label:${option}`}>
            {option}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default BaseTransferOption;
